module.exports = __webpack_public_path__ + "img/acount.0b2e0dec.png";